<template>
    <div class="az-form-content">
        <v-container fluid grid-list-xl>
            <dados-gerais v-model="licitacao" :exibirAno="exibirAno"></dados-gerais>
        </v-container>
    </div>
</template>

<script>
    import {mapState} from 'vuex'
    import DadosGerais from '../commons/DadosGerais'

    export default {
        name: 'LicitacaoFornecedorDadosGerais',
        components: {DadosGerais},
        computed: {
            exibirAno() {
                return this.parametros.propriedadesLicitacao.exibirAno
            },
            ...mapState(['licitacao', 'parametros'])
        }
    }
</script>